import { render, staticRenderFns } from "./Toggle.vue?vue&type=template&id=8da0d0f8&"
import script from "./Toggle.vue?vue&type=script&lang=js&"
export * from "./Toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8da0d0f8')) {
      api.createRecord('8da0d0f8', component.options)
    } else {
      api.reload('8da0d0f8', component.options)
    }
    module.hot.accept("./Toggle.vue?vue&type=template&id=8da0d0f8&", function () {
      api.rerender('8da0d0f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Toggle.vue"
export default component.exports